import { useQuery } from '@apollo/client';
import { LocationScopeEnum } from '../graphql/types';
import { cityAndLocationsQuery } from '../api/queries';
import { CityAndLocationsQuery } from '../graphql/graphql';

export const useCityAndLocationsQuery = (
  cityId = '',
  scope = LocationScopeEnum.All,
  limit = 1000,
  skip = false
) => {
  const variables = { cityId, scope, limit };
  return useQuery<CityAndLocationsQuery>(cityAndLocationsQuery, {
    variables,
    skip: skip || !+cityId
  });
};
